import React from 'react';
import { useTranslation } from 'react-i18next';
import ActionBarButton from '../../_partials/ActionBarButton';
export var OrderCommissionButton = function (_a) {
    var deviation = _a.deviation, onClick = _a.onClick, isOpen = _a.isOpen;
    var t = useTranslation().t;
    return (React.createElement(ActionBarButton, { view: "b18", isDisabled: !isOpen, onClick: function () { return onClick(deviation); } }, t(isOpen ? 'actionbar.orderCommission' : 'actionbar.closedCommission')));
};
OrderCommissionButton.displayName = 'OrderCommissionButton';
export default OrderCommissionButton;
//# sourceMappingURL=OrderCommissionButton.js.map